import * as React from "react";
import * as Grid from "react-bootstrap/lib/Grid";
import * as Col from "react-bootstrap/lib/Col";
import {Link} from "react-router-dom";
import * as Row from "react-bootstrap/lib/Row";
import Application from "../../metamodel/Application";


export default class AboutPage extends React.Component<{content: string, logoUrl: string, headerUrl: string, metaModel: Application}, {}> {

    public render() {
        return <section id="main">
            <div className="header-page bg-scroll m-bottom-0"
                 style={{backgroundImage: `url(${this.props.headerUrl})`}}>
                <div className="container">
                    <div className="header-page__form header-page__form--high">
                        <div className="tb">
                            <div className="tb__cell">
                                <Col sm={12} md={12}>
                                    <div className="header-page__banner text-center">
                                        <a href="/" target="_blank">
                                            <img className="header-img" width={200}
                                                 src={this.props.logoUrl}
                                                 alt="Logo"/>
                                        </a>
                                        <div className={"inline-block"}>
                                            <h2 className="banner__title">{this.props.metaModel.name}</h2>
                                            <Link to="/over-de-app"
                                                  className="listgo-btn btn-primary">Meer informatie</Link>
                                        </div>
                                    </div>
                                </Col>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-page__breadcrumb">
                    <div className="container">
                        <ol className="wo_breadcrumb">
                            <li><Link to="/">Home</Link></li>
                            <li><span>Over deze app</span></li>
                        </ol>
                    </div>
                </div>
            </div>
            {this.props.content === null ? (
            <div className="section p-top-10 wo_blog">
                <Grid>
                    <Row>
                        <Col md={10} mdOffset={1} lg={8} lgOffset={2}>
                            <div className="post post__single">
                                <div className="post__body">
                                    <div className="post__entry">
                                        <h1>Over '{this.props.metaModel.name}'</h1>
                                        <p>
                                            De webapplicatie ‘bijenplanten’ is gemaakt in het kader van het Nederland
                                            zoemt project en is bedoeld als hulpmiddel voor iedereen die (wilde) bijen
                                            wil helpen. Alle planten in deze app zijn geschikt voor wilde bijen, hommels
                                            en/of honingbijen en kunnen gebruikt worden in tuinen. Door te zorgen dat er
                                            zo lang mogelijk planten bloeien in een tuin worden de bijen het best
                                            geholpen. Verschillende filters helpen om de juiste plant voor de juiste
                                            plek te vinden. De app is ontwikkeld door het <a
                                            href="https://ontwikkelcentrum.nl/" target="_blank">Ontwikkelcentrum</a> en
                                            de lijst
                                            planten en een groot deel van de foto’s is afkomstig van Arie Koster. Kijk
                                            op zijn website <a target="_blank" href="http://www.wildebijen.nl/">www.wildebijen.nl</a> voor meer informatie over alle wilde bijen
                                            in Nederland.<br/><br/>

                                            Nederland Zoemt is een project van <a target="_blank" href="http://www.landschappen.nl/">LandschappenNL</a>,&nbsp;
                                            <a target="_blank" href="https://www.naturalis.nl/nl/">Naturalis</a>,&nbsp;
                                            <a href="https://www.ivn.nl/" target="_blank">IVN</a>&nbsp;en <a target="_blank" href="https://www.natuurenmilieu.nl/">Natuur & Milieu</a>, mogelijk gemaakt dankzij een extra bijdrage van de&nbsp;
                                            <a target="_blank" href="https://www.postcodeloterij.nl/goede-doelen/bijzondere-projecten/de-bij-in-de-hoofdrol-1">Nationale Postcode Loterij</a>, met als doel het structureel vergroten van voedselaanbod
                                            en nestgelegenheid voor wilde bijen in Nederland.
                                        </p>
                                        <p>
                                            De apps van het Onwikkelcentrum zijn handig om op je smartphone of tablet te zetten.<br/>
                                            Het enige wat je nodig hebt, is toegang tot de webapp en een internetverbinding.<br/>
                                            <a href="https://ontwikkelcentrum.nl/app-toevoegen-aan-je-startscherm" target="_blank">Kijk hier voor meer informatie</a>.
                                        </p>
                                        <div className="nav-filter">
                                            <Link className="active" to="/">Terug naar homepage</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </div>) : <div className="section p-top-10 wo_blog" dangerouslySetInnerHTML={{__html: this.props.content}}/>}
            {this.props.content === null ? (
            <div className="section p-bottom-40" style={{background: "#f5f5f5"}}>
                <div className="container">
                    <div className="heading-title header-title--1 text-center">
                        <div className="heading-title__h-group">
                            <h2 className="heading-title__title">Mogelijk gemaakt door</h2>
                        </div>
                        <Row>
                            <Col md={4}>
                                <a href="http://www.landschappen.nl/" target="_blank">
                                    <img src="/appdata/nederland_zoemt/logos/landschappenNL.png" alt="LandschappenNL"/>
                                </a>
                            </Col>
                            <Col md={4}>
                                <a href="https://www.naturalis.nl/nl/" target="_blank">
                                    <img src="/appdata/nederland_zoemt/logos/naturalis.png" alt="Naturalis"/>
                                </a>
                            </Col>
                            <Col md={4}>
                                <a href="https://www.ivn.nl/" target="_blank">
                                    <img src="/appdata/nederland_zoemt/logos/ivn.png" alt="IVN"/>
                                </a>
                            </Col>
                        </Row>
                        <Row className="m-top-50">
                            <Col md={4}>
                                <a href="https://www.natuurenmilieu.nl/" target="_blank">
                                    <img src="/appdata/nederland_zoemt/logos/natuur_en_milieu.png" alt="Natuur en Milieu"/>
                                </a>
                            </Col>
                            <Col md={4}>
                                <a href="https://www.postcodeloterij.nl/goede-doelen/bijzondere-projecten/de-bij-in-de-hoofdrol-1" target="_blank">
                                    <img src="/appdata/nederland_zoemt/logos/nationale_postcode_loterij.png" alt="Nationale Postcode Loterij"/>
                                </a>
                            </Col>
                            <Col md={4}>
                                <a href="https://ontwikkelcentrum.nl/" target="_blank">
                                    <img src="/appdata/nederland_zoemt/logos/ontwikkelcentrum.png" alt="Ontwikkelcentrum"/>
                                </a>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>): undefined }
        </section>;
    }
}


// WEBPACK FOOTER //
// ./src/pages/client/aboutPage.tsx